<template>
  <div class="lime-header">
   <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
    <nav class="navbar navbar-expand-lg">
      <section id="navigation-toggle1" class="material-design-hamburger navigation-toggle" v-on:click="toggle()">
        <a href="javascript:void(0)" class="button-collapse material-design-hamburger__icon">
          <span class="material-design-hamburger__layer"></span>
        </a>
      </section>
      <section id="navigation-toggle2" class="material-design-hamburger navigation-toggle2" v-on:click="toggle1()">
        <a href="javascript:void(0)" class="button-collapse material-design-hamburger__icon ">
          <span class="material-design-hamburger__layer material-design-hamburger__icon--to-arrow"></span>
        </a>
      </section>
      <a class="navbar-brand" href="#">
      <img v-bind:src=" siteLogo ">
      </a>
        <button class="navbar-toggler" id="navbarSupportedContenttrue" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" v-on:click="toggleopen()">
          <i class="material-icons key_arrow">keyboard_arrow_down</i>
        </button>
        
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
         <div v-if="isAdmin">
          <form class="form-inline my-2 my-lg-0 search" id="search" action="/searchData">
            <input class="form-control mr-sm-2" type="search" name="text" id="txt-search" v-model="input.search" v-on:keyup.enter="searchData()" placeholder="Search for projects, apps, pages..." aria-label="Search" />
            <input type="button" class="btn btn-primary" value="Search" v-on:click="searchData()" />
          </form>
          </div>
          
          <ul class="navbar-nav ml-auto" id="parent-list">
            <li class="nav-item">
              <a class="nav-link" id="avatarBtn" href="#">
                <div class="username">
                  <img v-if="profImage !== ''" v-bind:src=" profImage ">
                  <img v-else src="@/assets/logo.png">
                  <span>{{ghostuserName}}</span>
                </div>
              </a>
            </li>
            <li class="nav-item dropdown" id="dropdownAdd">
              <a class="nav-link dropdown-toggle" id="addtrue" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-on:click="menuopen()">
                <i class="material-icons">more_vert</i>
              </a>
              <ul class="dropdown-menu dropdown-menu-right" id="menushow">
                <li v-if="isAdmin"><router-link to="/adminprofile" class="dropdown-item" >Profile</router-link></li>
                <li v-if="isUser"><router-link to="/userprofile" class="dropdown-item" >Profile</router-link></li>
                <li v-if="isAdmin"><router-link to="/account-setting" class="dropdown-item">Account Setting</router-link></li>
                <li><a class="dropdown-item" href="#" v-on:click="logout()">Log Out</a></li>
              </ul>
            </li>
          </ul>
        </div>
        </nav>
        
        <div id="updateavatar" class="modal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <flash-message class="myCustomClass"></flash-message>
                <h5 class="modal-title" id="exampleModalLabel">Change Avatar</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <i class="material-icons">close</i>
                </button>
              </div>
              <form id="myForm" action="#" v-on:keyup.enter="update()">
               <p style="color:red;text-align:center">{{ errorMessage }}</p>
              <p v-if="errors.length">
                
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
                <div class="modal-body">
                  <div class="avatar">
                    <img v-bind:src=" profImage ">
                  </div>
                  <div class="form-group">
                    <!-- <input type="file" class="form-control" placeholder="Enter Amount" /> -->
                    <input class="form-control" type="file" name="ghost_logo" ref="fileadd" id="fileadd"  v-on:change="handleFileUpload()" />
                  </div>
                </div>
                <div class="modal-footer">
                  <input type="button" class="btn btn-primary" value="Save" v-on:click="update()">
                  <!-- <button type="button" class="btn btn-primary">Save</button> -->
                  <button type="button" class="btn btn-secondary" v-on:click="avtarpopupclose()">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>
        </template>
        <script>
          import axios from 'axios'
          import Loading from 'vue-loading-overlay'
          import 'vue-loading-overlay/dist/vue-loading.css'
          require('vue-flash-message/dist/vue-flash-message.min.css')
          export default {
            name: 'HeaderMain',
            components: {
              Loading
            },
            data () {
              return {
                errors: [],
                errorMessage: '',
                isLoading: false,
                fullPage: true,
                file: '',
                role: localStorage.getItem('role'),
                profileimage: localStorage.getItem('profile_img'),
                ghostlogo: localStorage.getItem('account_image'),
                username: localStorage.getItem('username'),
                input: {
                  search: ''
                },
                siteLogo: '',
                profImage: '',
                ghostuserName: ''
              }
            },
            computed: {
              isAdmin () {
                return this.role && this.role === 'admin'
              },
              isUser () {
                return this.role && this.role === 'user'
              }
            },
            methods: {
              update () {
                this.errors = []
                var fuData = document.getElementById('fileadd')
                var FileUploadPath = fuData.value
                // var ext = fileName.toString().indexOf('.') + 1
                var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase()
                if (FileUploadPath === '') {
                  // alert('1')
                  this.errors.push('File is Required')
                } else if (!this.checkExtension(ext)) {
                  this.errors.push('Only jpeg , png , gif Allowed')
                } else {
                  var jwttoken = localStorage.getItem('jwt')
                  let formData = new FormData()
                  formData.append('uid', localStorage.getItem('uid'))
                  formData.append('file', this.file)
                  this.isLoading = true
                  axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/updateProfile',
                    formData,
                    {
                      headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': jwttoken
                      }
                    }
                  ).then(response => {
                    // console.log(response)
                    localStorage.setItem('profile_image', response.data.results[0].profile_image)
                    this.isLoading = false
                    // console.log(localStorage.getItem('profile_image'))
                    this.flash('Profile Image Updated Successfully', 'success', {
                      timeout: 1000,
                      beforeDestroy () {
                        location.reload()
                      }
                    })
                  })
                   .catch((error) => {
                    this.errorMessage = error.response.data.errors
                    this.isLoading = false
                  })
                }
              },
              avtarpopupclose () {
                 this.errors = []
                 var fuData = document.getElementById('fileadd')
                 var FileUploadPath = fuData.value
                 //alert(FileUploadPath)
                 
                var modal = document.getElementById('updateavatar')
                document.getElementById("myForm").reset()
                modal.style.display = 'none'
                window.onclick = function (event) {
                  if (event.target === modal) {
                    modal.style.display = 'none'
                  }
                }
              },
              handleFileUpload () {
                this.file = this.$refs.fileadd.files[0]
              },
              logout () {
                localStorage.removeItem('jwt')
                localStorage.removeItem('user')
                localStorage.removeItem('profileimage')
                localStorage.removeItem('uid')
                localStorage.removeItem('username')
                localStorage.removeItem('useremail')
                localStorage.removeItem('userid')
                localStorage.removeItem('searchData')
                this.isLoading = false
                this.$router.push('login')
              },
              method1 () {
                document.body.addEventListener('click', function () {
                  var body = document.getElementById('dropdownAdd')
                  var menushow = document.getElementById('menushow')
                  window.onload = function () {
                    var x = document.getElementById('addtrue').getAttribute('aria-expanded')
                    if (x === 'true') {
                      x = 'false'
                      body.classList.remove('show')
                      menushow.classList.remove('show')
                    }
                  }
                }, true)
              },
              toggle () {
                var body = document.body
                body.classList.add('background--blur')
                body.classList.add('sidebar-show')
                document.getElementById('navigation-toggle2').style.display = 'block'
                document.getElementById('navigation-toggle1').style.display = 'none'
              },
              toggle1 () {
                var body = document.body
                body.classList.remove('background--blur')
                body.classList.remove('sidebar-show')
                document.getElementById('navigation-toggle1').style.display = 'block'
                document.getElementById('navigation-toggle2').style.display = 'none'
              },
              menuopen () {
                var body = document.getElementById('dropdownAdd')
                body.classList.add('show')
                var menushow = document.getElementById('menushow')
                menushow.classList.add('show')
                var x = document.getElementById('addtrue').getAttribute('aria-expanded')
                if (x === 'true') {
                  x = 'false'
                  body.classList.remove('show')
                  menushow.classList.remove('show')
                } else {
                  x = 'true'
                }
                document.getElementById('addtrue').setAttribute('aria-expanded', x)
              },
              searchData () {
                var search = this.input.search
                if (search){
                this.$router.replace('/searchData?text=' + search)
                }
              },
              menuclose () {
                document.getElementById('parent-list').addEventListener('click', function (e) {
                  if (e.target.tagName === 'A') {
                    var body = document.getElementById('dropdownAdd')
                    var menushow = document.getElementById('menushow')
                    menushow.classList.add('show')
                    var x = document.getElementById('addtrue').getAttribute('aria-expanded')
                    if (x === 'true') {
                      x = 'false'
                      body.classList.remove('show')
                      menushow.classList.remove('show')
                    } else {
                      x = 'true'
                    }
                    document.getElementById('addtrue').setAttribute('aria-expanded', x)
                  }
                })
              },
              toggleopen () {
                var body = document.getElementById('navbarSupportedContent')
                body.classList.add('show')
                var x = document.getElementById('navbarSupportedContenttrue').getAttribute('aria-expanded')
                if (x === 'true') {
                  x = 'false'
                  body.classList.add('collapsed')
                  body.classList.remove('show')
                } else {
                  x = 'true'
                }
                document.getElementById('navbarSupportedContenttrue').setAttribute('aria-expanded', x)
              },
              click () {
                var modal = document.getElementById('updateavatar')
                var btn = document.getElementById('avatarBtn')
                var span = document.getElementsByClassName('close')[0]
                btn.onclick = function () {
                  modal.style.display = 'block'
                }
                span.onclick = function () {
                  modal.style.display = 'none'
                }
                window.onclick = function (event) {
                  if (event.target === modal) {
                    modal.style.display = 'none'
                  }
                }
              },
              showLogo () {
                var jwttoken = localStorage.getItem('jwt')
                this.isLoading = true
                axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting', {
                  headers: {
                    'x-access-token': jwttoken
                  }})
                  .then(response => {
                    this.siteLogo = response.data.results[0].ghost_logo
                    this.isLoading = false
                  })
                  .catch((error) => {
                    // this.errorMessage = response.data.errors
                    console.log(error)
                    this.isLoading = false
                  })
              },
              showProfileImage () {
                var jwttoken = localStorage.getItem('jwt')
                var uid = localStorage.getItem('uid')
                this.isLoading = true
                axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserProfile' + '?' + 'uid' + '=' + uid, {
                  headers: {
                    'x-access-token': jwttoken
                  }})
                  .then(response => {
                    this.profImage = response.data.results[0].profile_image
                    this.ghostuserName = response.data.results[0].username
                    this.isLoading = false
                    console.log(this.userDetails)
                  })
                  .catch((error) => {
                    console.log(error)
                    this.isLoading = false
                  })
              },
              menueCloseOnClick () {
                document.body.addEventListener('click', function () {
                  var isMobileVersion = document.getElementsByClassName('show')
                  if (isMobileVersion.length > 0) {
                    var body = document.getElementById('dropdownAdd')
                    var menushow = document.getElementById('menushow')
                    menushow.classList.add('show')
                    var x = document.getElementById('addtrue').getAttribute('aria-expanded')
                    if (x === 'true') {
                      x = 'false'
                      body.classList.remove('show')
                      menushow.classList.remove('show')
                    } else {
                      x = 'true'
                    }
                    document.getElementById('addtrue').setAttribute('aria-expanded', x)
                  }
                }
                  , true)
              }
            },
            mounted () {
              this.menueCloseOnClick()
              this.showLogo()
              this.method1()
              this.click()
              this.toggle1()
              this.toggle()
              this.menuclose()
              this.showProfileImage()
              var body = document.body
              body.classList.remove('background--blur')
              body.classList.remove('sidebar-show')
              document.getElementById('navigation-toggle1').style.display = 'block'
              document.getElementById('navigation-toggle2').style.display = 'none'
            }
          }
          </script>
        <style>
          .navigation-toggle2{
            display:none;
          }
          /*.lime-header .search{
            display:flex;
            justify-content: flex-end;
            position:relative;

          }
          .lime-header .search input{
            height:36px;
          }
          .lime-header .search:before{
            top:-6px;
            left: 112px;
          }
          */
          .lime-header .search .btn-primary{
            background: #037afb!important;
            width:auto;
            color:#fff;
            padding:0 15px!important;
            width: 100px;
            position: absolute;
            right: 15px;
            height: 40px;
          }
           /*#txt-search{
            width:auto;
            border: 1px solid #ccc;
            padding: 15px 15px 15px 40px!important;
          }*/
          
        </style>
        


// WEBPACK FOOTER //
// src/components/HeaderMain.vue